// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productInformationStyles } from "@awc/Overrides/Widgets/ProductList/ProductListProductInformation";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { ellipsis } from "@awc/XDL/Utilities";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const descriptionStyles: TypographyPresentationProps = {
    size: fontConfig.fontSize.regular,
    weight: fontConfig.weight.bold,
    lineHeight: fontConfig.lineHeight.xSmall,
    css: css`
        margin-bottom: 8px;
        ${ellipsis(1)}
    `,
};

productInformationStyles.container = {
    gap: 0,
};

productInformationStyles.descriptionStyles = {
    productDetailLink: {
        typographyProps: {
            ...descriptionStyles,
        },
    },
    productDetailDescription: {
        ...descriptionStyles,
    },
};

productInformationStyles.textBadgeGridItem = {
    width: 12,
    css: css`
        gap: 4px;
    `,
};
productInformationStyles.partNumbersGridItem = {
    ...productInformationStyles.partNumbersGridItem,
};
productInformationStyles.partNumbersStyles = {
    container: {
        css: css`
            margin-bottom: 8px;
        `,
    },
};
